//@author: mandy
import { DataAccess } from "../dataaccess/data.access";

export class PersistentSessionService {
    public static create(username: any) {
        return DataAccess.get(
            DataAccess.injectCaller(
                `/session/persistent.json?username=${username}&always_create=Y`,
                "PersistentSessionService.get",
            ),
        );
    }

    public static delete(sessionId: string) {
        return DataAccess.delete(
            DataAccess.injectCaller(
                `/session/persistent.json?persistentSessionId=${sessionId}`,
                "PersistentSessionService.delete",
            ),
        );
    }
}
